import React from "react";

export function useDropdownHover(delay = 150) {
  const [open, setOpen] = React.useState(false);
  const timeoutRef = React.useRef<ReturnType<typeof setTimeout> | null>(null);

  const handleMouseEnter = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
    setOpen(true);
  };

  const handleMouseLeave = (e: React.MouseEvent) => {
    if (
      e.relatedTarget instanceof Element &&
      e.relatedTarget.closest('[data-slot="dropdown-menu-content"]')
    ) {
      return;
    }
    timeoutRef.current = setTimeout(() => {
      setOpen(false);
    }, delay);
  };

  React.useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return { open, setOpen, handleMouseEnter, handleMouseLeave };
}
